$(document).ready(function () {
  $('.bestseller-games-list').slick({
    dots: false,
    infinite: false,
    speed: 800,
    slidesToShow: 6,
    slidesToScroll: 6,
    prevArrow: '<button type="button" class="slick-prev"><</button>',
    nextArrow: '<button type="button" class="slick-next">></button>',
    responsive: [
      {
        breakpoint: 1537,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
          infinite: false,
          dots: false
        }
      },
      {
        breakpoint: 883,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: false,
          dots: false
        }
      },
      {
        breakpoint: 493,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 320,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  $('.slider-prev').click(function () {
    $(this).closest('.section').find(".list").slick('slickPrev');
  });

  $('.slider-next').click(function () {
    $(this).closest('.section').find(".list").slick('slickNext');
  });
});
